// extracted by mini-css-extract-plugin
module.exports = {"darkYellow":"#d2b850","invite":"Invite_invite__xCkIe","italics":"Invite_italics__3UrbH"};